import { AuthUser, SCDPerson } from '@tran-monorepo/interfaces';
import { ApplicationUser } from '@tran-monorepo/interfaces/applications';

export function mapAuthUserToApplicationUser(claims: AuthUser): ApplicationUser {
    return {
        gid: claims.gid ?? '',
        firstName: claims.given_name ?? '',
        lastName: claims.family_name ?? '',
        email: claims.mail ?? '',
        orgCode: claims.org_code ?? '',
        createdAt: '',
        updatedAt: ''
    };
}

export function mapApplicationUserToAuthUser(user: ApplicationUser): AuthUser {
    return {
        gid: user.gid,
        given_name: user.firstName,
        family_name: user.lastName,
        mail: user.email,
        org_code: user.orgCode
    } as AuthUser;
}

export function mapScdPersonToApplicationUser(person: SCDPerson | null): ApplicationUser {
    if (!person) {
        return {} as ApplicationUser;
    }

    return {
        gid: typeof person === 'string' ? person : person.gid,
        firstName: typeof person === 'string' ? '' : person.firstName,
        lastName: typeof person === 'string' ? '' : person.lastName,
        email: typeof person === 'string' ? '' : person.mail,
        orgCode: typeof person === 'string' ? '' : (person.department ?? '')
    };
}

export function getApplicationUserDisplayName(user: ApplicationUser): string {
    if (!user) {
        return '';
    }

    const { firstName, lastName, orgCode } = user;

    return `${firstName} ${lastName}${orgCode ? ' (' + orgCode + ')' : ''}`;
}
